/* esm.sh - @radix-ui/react-separator@1.1.8 */
export * from "/*@radix-ui/react-separator@1.1.8/esnext/react-separator.mjs";
